import { Preferences } from '@capacitor/preferences';
import { createStore } from '@stencil/store';

const { state, onChange } = createStore({
  onlineCount: 0,
  ipAPIresponse: { lat: 0, lon: 0, city: '', country: '', timezone: '', countryCode: '' },
  presenceList: null,
  worldMessages: [],
  reminders: [],
  isEditNotifications: false,
  lastStreakScore: null,
  breathingStats: [],
  totalStats: {
    totalBreathingOutTime: 0,
    totalBreathingInTime: 0,
    totalBreathingTime: 0,
    averageBreathingInTime: 0,
    averageBreathingOutTime: 0,
    averageBreathingTime: 0,
    numberOfCycles: 0,
    averageCyclePerMinute: 0,
  },
  breathingHistory: [],
  breathingResults: {
    totalStats: {
      totalBreathingOutTime: 0,
      totalBreathingInTime: 0,
      totalBreathingTime: 0,
      averageBreathingInTime: 0,
      averageBreathingOutTime: 0,
      averageBreathingTime: 0,
      numberOfCycles: 0,
      averageCyclePerMinute: 0,
    },
    stats: [],
    numberOfCycles: 0,
  },
});

onChange('breathingHistory', value => {
  console.log('history changed', value);
  Preferences.set({
    key: 'breathingHistory',
    value: JSON.stringify(value),
  });
});

export default state;
